import { Address } from './address';

export enum DELIVERY_SHIPMENT_STATUS {
  zero = 0,
  ready_for_pickup = 1,
  failed_pickup = 2,
  picked_up = 3,
  failed_pickup_collected = 4,
  dropped_off = 5,
  failed_dropoff = 6,
  cancelled = 7,
  failed_dropoff_collected = 8,
}

export const DELIVERY_SHIPMENT_STATUS_NAME_MAP: {
  [key: number]: string;
} = {
  0: 'All',
  1: 'Ready for Pickup',
  2: 'Failed Pickup',
  3: 'Picked Up',
  4: 'Failed Pickup Collected',
  5: 'Dropped Off',
  6: 'Failed Dropoff',
  7: 'Cancelled',
  8: 'Failed Dropoff Collected',
};

export const DELIVERY_SHIPMENT_STATUS_COLOR_MAP: {
  [key in DELIVERY_SHIPMENT_STATUS]: string;
} = {
  [DELIVERY_SHIPMENT_STATUS.zero]: 'black',
  [DELIVERY_SHIPMENT_STATUS.ready_for_pickup]: 'navy',
  [DELIVERY_SHIPMENT_STATUS.failed_pickup]: 'darkred',
  [DELIVERY_SHIPMENT_STATUS.picked_up]: 'green',
  [DELIVERY_SHIPMENT_STATUS.failed_pickup_collected]: 'red',
  [DELIVERY_SHIPMENT_STATUS.dropped_off]: 'green',
  [DELIVERY_SHIPMENT_STATUS.failed_dropoff]: 'magenta',
  [DELIVERY_SHIPMENT_STATUS.cancelled]: 'red',
  [DELIVERY_SHIPMENT_STATUS.failed_dropoff_collected]: 'orange',
};

export const DUMMY_SHIPMENT_ACTIONS: ShipmentAction[] = [
  {
    standard_shipment_id: 1,
    status_after_action: DELIVERY_SHIPMENT_STATUS.ready_for_pickup,
    status_after_action_name:
      DELIVERY_SHIPMENT_STATUS_NAME_MAP[
        DELIVERY_SHIPMENT_STATUS.ready_for_pickup
      ],
    action_date: '2024-05-28T00:00:00.000Z', // Today's date in UTC
    userId: 1,
  },
  {
    standard_shipment_id: 1,
    status_after_action: DELIVERY_SHIPMENT_STATUS.failed_pickup,
    status_after_action_name:
      DELIVERY_SHIPMENT_STATUS_NAME_MAP[DELIVERY_SHIPMENT_STATUS.failed_pickup],
    action_date: '2024-05-28T09:00:00.000Z', // Example time after order placement
    userId: 1,
  },
  {
    standard_shipment_id: 1,
    status_after_action: DELIVERY_SHIPMENT_STATUS.picked_up,
    status_after_action_name:
      DELIVERY_SHIPMENT_STATUS_NAME_MAP[DELIVERY_SHIPMENT_STATUS.picked_up],
    action_date: '2024-05-28T10:00:00.000Z', // Example time after requested
    userId: 1,
  },
  {
    standard_shipment_id: 1,
    status_after_action: DELIVERY_SHIPMENT_STATUS.failed_pickup_collected,
    status_after_action_name:
      DELIVERY_SHIPMENT_STATUS_NAME_MAP[
        DELIVERY_SHIPMENT_STATUS.failed_pickup_collected
      ],
    action_date: '2024-05-28T11:00:00.000Z', // Example time after accepted
    userId: 1,
  },
  {
    standard_shipment_id: 1,
    status_after_action: DELIVERY_SHIPMENT_STATUS.dropped_off,
    status_after_action_name:
      DELIVERY_SHIPMENT_STATUS_NAME_MAP[DELIVERY_SHIPMENT_STATUS.dropped_off],
    action_date: '2024-05-28T12:00:00.000Z', // Example time after accepted/requested
    userId: 1,
  },
  {
    standard_shipment_id: 1,
    status_after_action: DELIVERY_SHIPMENT_STATUS.failed_dropoff,
    status_after_action_name:
      DELIVERY_SHIPMENT_STATUS_NAME_MAP[
        DELIVERY_SHIPMENT_STATUS.failed_dropoff
      ],
    action_date: '2024-05-28T13:00:00.000Z', // Example time after in-transit
    userId: 1,
  },

  {
    standard_shipment_id: 1,
    status_after_action: DELIVERY_SHIPMENT_STATUS.cancelled,
    status_after_action_name:
      DELIVERY_SHIPMENT_STATUS_NAME_MAP[DELIVERY_SHIPMENT_STATUS.cancelled],
    action_date: '2024-05-28T14:00:00.000Z', // Example
    userId: 1,
  },
  {
    standard_shipment_id: 1,
    status_after_action: DELIVERY_SHIPMENT_STATUS.failed_dropoff_collected,
    status_after_action_name:
      DELIVERY_SHIPMENT_STATUS_NAME_MAP[
        DELIVERY_SHIPMENT_STATUS.failed_dropoff_collected
      ],
    action_date: '2024-05-28T15:00:00.000Z', // Example
    userId: 1,
  },
];

export interface Package {
  tracking_code: string;
  weight: number;
  height: number;
  width: number;
  length: number;
}

export type PackageTrackingType = {
  name: string;
  width: number;
  height: number;
  length: number;
  image: any;
};

export type TrackingData = {
  id: number;
  tracking_code: string;
  weight: string;
  selected: boolean;
  package: PackageTrackingType;
};

export interface LastMileShift {
  id: number;
  finished: boolean;
  start_datetime: string;
  end_datetime: string;
  city_id: number;
  registered_carriers: any[];
  desired_carriers: number;
  shipments_count: number;
  is_recieving_new_orders: boolean;
  is_active: boolean;
}

export interface ShipmentAction {
  standard_shipment_id: number;
  status_after_action: DELIVERY_SHIPMENT_STATUS;
  status_after_action_name: string;
  action_date: string;
  userId: number;
}

export interface Shipment {
  id: number;
  delivery_type: number;
  delivery_type_name: string;
  order_id: number;
  source_address: Address;
  source_name: string;
  packages: Package[];
  finished: boolean;
  flammable: boolean;
  fragile: boolean;
  keep_dry: boolean;
  requires_security_code: boolean;
  destination_phone_number: string;
  destination_name: string;
  planned_destination_address: Address;
  dropped_off_address?: Address;
  customer_delivery_notes: string;
  carrier_notes?: any;
  status: DELIVERY_SHIPMENT_STATUS;
  current_carrier_id?: number;
  status_name: string;
  required_capacity: number;
  shipment_actions: ShipmentAction[];
  cash_to_collect: string;
  delivery_fee: string;
  order_price: string;
  payment_type: number;
  payment_type_name: string;
  last_mile_shift: LastMileShift;
}
